import React, { createContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import config from "../../src/config/index";

import axios from "axios";

import agreementdata from "../data/Agreementdata";

import LoadingWidget from "../components/LoadingWidget";

export const ProtoContractContext = createContext();

export const  ProtoContractProvider = (props) => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const { id } = useParams();

  const token = localStorage.getItem("token");

  useEffect(() => {
    setIsLoading(true);
    if (id) {
      axios
        .get(`${config.backendHost}protocontracts/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          console.log("Customer1:", res.data);
          setIsLoading(false);
        
          setData(res.data);
        })
        .catch(() => {
          console.log("Customer2:", agreementdata);
          setIsLoading(false);
          setData(agreementdata);
        });
    } else {
      console.log("Customer3:", agreementdata);
      setIsLoading(false);
      setData(prev => prev === undefined ? agreementdata : prev);
    }
  }, [id, token]);

  return (
    <>
      {!isLoading ? (
        <ProtoContractContext.Provider value={[data, setData]}>
          {props.children}
        </ProtoContractContext.Provider>
      ) : (
        <LoadingWidget />
      )}
    </>
  );
};
